import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { Category } from '../constants/ConfigStaffblog'
import StaffBlog from './StaffBlog'
import request from 'axios'
import { glasConfig } from '../constants/Config'
import { connect } from 'react-redux'
import * as CategoryBlogActions from './../actions/CategoryBlogAction'
import { TextField, InputAdornment, IconButton, Box, InputBase } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

class StaffBlogHome extends Component {
	constructor(props) {
		super(props)
		this.state = {
			page: 1,
			size: 12,
			category: 0,
			keyword: '',
			tempKeyword: '',
			listCategory: []
		}
	}
	componentDidMount() {
		const { dispatch } = this.props
		dispatch(CategoryBlogActions.getCategoryBlog())
	}
	componentWillMount() {
		const { match, } = this.props
		this.getData(match)

	}

	componentWillReceiveProps(nextProps) {
		const { match } = nextProps
		this.getData(match)
	}

	/**
	 * 記事詳細を取得
	 */
	getData(match) {
		const params = {
			page: match.params.page === undefined ? 1 : match.params.page,
			size: match.params.size === undefined ? 10 : match.params.size,
			category:
				match.params.category === undefined
					? ''
					: match.params.category,
		}
		this.setState(params)
	}

	handleSearch = () => {
		this.setState({ keyword: this.state.tempKeyword }, () => {
			console.log("Search triggered:", this.state.keyword);
		  });
	};

	handleInputChange = (e) => {
		const value = e.target.value;
		this.setState({ tempKeyword: value });
	
		if (value.trim() === '') {
			this.setState({ keyword: '' });
		}
	};

	render() {
		const { CategoryBlog } = this.props
		const baseurl = '/home/staffblog/1'
		return (
			<div className="content">
				<h1 className="content__title">運営ブログ</h1>
				<Box
							sx={{
								display: 'flex',
								alignItems: 'center',
								width: 805,
								border: '1px solid #ccc',
								overflow: 'hidden',
								backgroundColor: '#fff',
							}}
							>
							<SearchIcon sx={{ color: '#757575', paddingLeft: '10px' }} />
							<InputBase
								placeholder="キーワードを入力してください"
								value={this.state.tempKeyword}
								onChange={this.handleInputChange}
								onKeyDown={(e) => {
									if (e.key === "Enter") this.handleSearch();
								}}
								sx={{ 
								flex: 1,
								padding: '4px 12px',
								}}
							/>
							<IconButton
								sx={{
								backgroundColor: '#11AD9D',
								borderRadius: 0,
								padding: '10px 12px',
								'&:hover': {
									backgroundColor: '#11AD9D',
								},
								}}
								onClick={this.handleSearch}
							>
								<p style={{ color:'white', fontSize: '15px'}}>検索</p>
							</IconButton>
							</Box>
				<nav className="lead-nav lead-nav-blog">
					<ul className="list lead_nav">
						{
							CategoryBlog.data && CategoryBlog.data.map((item, index) => {
								const className =
									item.category_id == this.state.category
										? 'btn-tab is-active'
										: 'btn-tab'
								return (
									<li key={item.term_id || index} className="list__item">
										<Link
											className={className}
											to={item.category_id == 0 ? baseurl : `${baseurl}/${item.category_id}`} /// do ben webview bao khong can lay dong, mac ke case bi sai
										>
											{item.category_name}
										</Link>
									</li>
								)
							})
						}
					</ul>
				</nav>
				<StaffBlog
					keyword = {this.state.keyword}
					category={this.state.category}
					page={this.state.page}
					size={this.state.size}
					pager={true}
				/>
			</div>
		)
	}
}
const mapStateToProps = (store) => {
	return {
		CategoryBlog: store.CategoryBlog,
	}
}
export default connect(mapStateToProps)(StaffBlogHome)
